import React from "react";
import { Trophy, GraduationCap, X } from "lucide-react";
function CourseActivatedModal({
  isOpen,
  onClose,
  courseName,
  onStartLearning,
  onGoDashboard,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm p-3 sm:p-4 lg:pt-20">
      <div
        className="
    relative
    w-full 
    max-w-md
    lg:max-w-[450px]
    rounded-[32px]
    bg-white
    p-6 lg:p-4
    shadow-2xl
  "
      >
        {/* CLOSE */}
        <button
          onClick={onClose}
          className="absolute right-3 top-3 sm:right-4 sm:top-4 rounded-full bg-gray-100 p-2"
        >
          <X size={18} />
        </button>

        {/* ICON */}
       <div
  className="
    mx-auto
    flex
    h-12 w-12
    sm:h-12 sm:w-12
    md:h-28 md:w-28
    lg:h-16 lg:w-16
    items-center
    justify-center
    rounded-full
    bg-[#F3EAFF]
  "
>
  <Trophy size={32} className="text-[#F4B400]" />
</div>

        {/* HEADING */}
        <h2 className="mt-2 text-center text-[20px] lg:text-[20px] font-bold text-[#4B1D67]">
          Congratulations! 🎉
        </h2>

        <p className="mt-2 text-center text-[14px] text-gray-600">
          Your course has been activated successfully.
        </p>

        <p className="mt-2 text-center text-[14px] text-gray-500">
          Start learning now and take one step closer to your dream career.
        </p>

        {/* PLAN CARD */}
        <div className="mt-2 rounded-[22px] border border-[#E7DDF8] p-2">
          <div className="flex flex-col sm:flex-row items-center sm:items-start gap-4">
            <div className="flex h-12 w-12 lg:h-24 lg:w-28 items-center justify-center rounded-[18px] bg-[#F3EAFF]">
              <GraduationCap size={32} className="text-[#4B1D67]" />
            </div>
            <div className="text-center sm:text-left">
              <h3 className="text-lg lg:text-sm font-bold text-[#25114D]">
                {" "}
                {courseName}{" "}
              </h3>
              <div className="mt-2 text-[#4B1D67] text-sm lg:text-sm">
                <p>✅ Full Access Granted</p>
                <p>📚 120K+ Questions</p>
                <p>♾️ Unlimited Practice</p>
              </div>
            </div>
          </div>
        </div>

        {/* BUTTONS */}
        <button
          onClick={onStartLearning}
          className="
    mt-4
    w-full lg:w-72
    rounded-[18px]
    bg-[#4B1D67]
    py-3 lg:py-2
    text-base lg:text-md
    font-bold
    text-white
  "
        >
          Start Learning Now →
        </button>

        <button
          onClick={onGoDashboard}
          className="
    mt-3
    w-full lg:w-72
    rounded-[18px]
    border-2
    border-[#FF8C52]
    py-3 lg:py-2
    text-base lg:text-md
    font-bold
    text-[#FF8C52]
  "
        >
          Go to Dashboard
        </button>

        <p className="mt-4 sm:mt-5 text-center text-xs sm:text-base lg:text-sm text-gray-500 px-2">
          💜 We're excited to have you in the{" "}
          <span className="font-semibold">{courseName}</span> family!
          <br />
          Happy Learning! 🚀
        </p>
      </div>
    </div>
  );
}

export default CourseActivatedModal;
